// @ts-check

import React, { useEffect, useRef, useState, memo } from 'react';
import { colors } from '../../../styles';
import { default as __ } from '../../../utils';
import Shape from '../../../components/utils/shape';
import { Column, Row } from '../../../components/utils/box';
import Orientation from '../../../components/utils/orientation';
import CourtSide from '../../../components/padel/court-side';
import Item, { ActionBar, NoResults, Pagination } from './item';

function MemoList({ seed, children }) {
  let [selectedMonth, setMonth] = useState(null);
  // let [selectedYear, setYear] = useState(null);

  let [selectedGames, setGames] = useState([]);
  let [query, setSort] = useState(false);
  let [filter, setFilter] = useState('all');

  let gamesOftheMonth = useRef(null);
  let winsOfTheMonth = useRef(null);
  let lossesOfTheMonth = useRef(null);
  let mvpsOfTheMonth = useRef(null);
  let currentMonth = useRef(null);

  useEffect(() => {
    let [month, year] = __.getCurrentDate();
    setMonth(month);
    // setYear(year);
    let filteredOpts = seed.filter(g => g.month === month);
    setGames(filteredOpts);
    currentMonth.current = month;
    gamesOftheMonth.current = filteredOpts;
    winsOfTheMonth.current = filteredOpts.filter(g => g.victory);
    mvpsOfTheMonth.current = filteredOpts.filter(g => g.mvp);
    lossesOfTheMonth.current = filteredOpts.filter(g => !g.victory);
  }, []);

  useEffect(() => {
    if (selectedMonth === null) return;

    if (filter === 'all') {
      setGames(gamesOftheMonth.current);
    } else if (filter === 'victory') {
      setGames(winsOfTheMonth.current);
    } else if (filter === 'loss') {
      setGames(lossesOfTheMonth.current);
    } else {
      setGames(mvpsOfTheMonth.current);
    }
  }, [filter]);

  useEffect(() => {
    if (!query) return;
    let games =
      filter === 'all'
        ? gamesOftheMonth.current
        : filter === 'victory'
        ? winsOfTheMonth.current
        : lossesOfTheMonth.current;
    let newOpts = games.filter(g => g.courtSide === query);
    setGames(newOpts);
  }, [query]);

  // const sortBy = (k, isAsc = true) => {
  //   if (!k) return;
  //   const sorted = gamesOftheMonth.sort((a, b) => {
  //     return (a[k] < b[k] ? -1 : 1) * (isAsc ? 1 : -1);
  //   });
  // };

  let clear = e => {
    e && e.preventDefault();
    setSort(false);
    setGames(gamesOftheMonth.current);
  };

  let filterBy = upcoming => {
    setSort(false);
    if (upcoming === filter) {
      setFilter('all');
    } else {
      setFilter(upcoming);
    }
  };

  let filterMonth = m => {
    setMonth(m);
    let filteredOpts = seed.filter(g => g.month === m);
    gamesOftheMonth.current = filteredOpts;
    winsOfTheMonth.current = filteredOpts.filter(g => g.victory);
    lossesOfTheMonth.current = filteredOpts.filter(g => g.victory);
    setGames(filteredOpts);
  };

  if (selectedMonth === null) return null;

  return (
    <>
      <Row x="between" y="center">
        <Row spacing="l" x="around" y="center">
          <ActionBar>
            <Shape.Triangle
              fill={
                filter && filter === 'victory'
                  ? colors.highlight
                  : colors.accent
              }
              size={60}
              cb={() => filterBy('victory')}
              transform={'translateY(4px)'}
            />

            <Shape.Triangle
              fill={
                filter && filter === 'loss' ? colors.highlight : colors.accent
              }
              size={60}
              cb={() => filterBy('loss')}
              transform={'rotate(180deg) translateY(10px)'}
            />
          </ActionBar>
        <Orientation
            landscape={
          <ActionBar>
            <Shape.Penta
              fill={
                filter && filter === 'mvp' ? colors.highlight : colors.accent
              }
              size={60}
              cb={() => filterBy('mvp')}
            />
          </ActionBar> }
          />

          <Orientation
            landscape={
              <ActionBar fixed>
                <CourtSide
                  variant={query}
                  shades={[
                    colors.accent,
                    query ? colors.highlight : colors.accent,
                  ]}
                  cb={() => setSort(query === 'right' ? 'left' : 'right')}
                />
              </ActionBar>
            }
          />
        </Row>

         
            <Row x="around" y="center" spacing="l">
              <Pagination
                cb={m => filterMonth(m)}
                month={selectedMonth}
                max={currentMonth.current}
              />
                 <Orientation
            landscape={
                     <p
                className="pill-button txt-xl pill-button-no-height "
                style={{ lineHeight: '90px' }}
                onClick={e => clear(e)}
              >
                &times;
              </p>
              }
          />
      </Row>
            </Row>

      {selectedGames.length === 0 ? (
        <NoResults m={selectedMonth} q={query} />
      ) : (
        <>
        <p className="txt-xl -accent padding-x txt-right"> mes {selectedMonth}</p>
        <ul className="grid grid--list grid-gap-l">
          {selectedGames.map(g => (
            <Item key={g.key} {...g} />
          ))}
        </ul>
    </>
      )}
    </>
  );
}

const sameSeed = (prevProps, nextProps) => {
  return prevProps.seed === nextProps.seed;
};

const List = memo(props => <MemoList {...props} />, sameSeed);

export default List;
